import { render, staticRenderFns } from "./DonattyPayment.vue?vue&type=template&id=ca239f1e&scoped=true&"
import script from "./DonattyPayment.vue?vue&type=script&lang=js&"
export * from "./DonattyPayment.vue?vue&type=script&lang=js&"
import style0 from "./DonattyPayment.vue?vue&type=style&index=0&id=ca239f1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca239f1e",
  null
  
)

export default component.exports